(function (_kmq) {
    'use strict';

    if (cookieConsent.analyticsEnabled) {
        _kmq.push(['record', 'Viewed Product Pages']);
    }

}(window._kmq));
